import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPowersComponent } from './simple-icons-powers.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPowersComponent ],
    exports:      [ SimpleIconsPowersComponent ],
    bootstrap:    []
})
export class SimpleIconsPowersModule {}
